import { render } from "./PersonRegistrationLaunchView.vue?vue&type=template&id=03b00c7a&scoped=true&ts=true"
import script from "./PersonRegistrationLaunchView.vue?vue&type=script&lang=ts"
export * from "./PersonRegistrationLaunchView.vue?vue&type=script&lang=ts"

import "./PersonRegistrationLaunchView.vue?vue&type=style&index=0&id=03b00c7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b00c7a"]])

export default __exports__